/**
 * Meta Pixel (Facebook Pixel) Utility Functions
 *
 * Provides helper functions for tracking events with Meta Pixel.
 * The pixel is initialized in index.html.
 */

/**
 * Check if fbq (Facebook Pixel) is available
 */
const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

/**
 * Track a PageView event
 * Call this on route changes to track page navigation
 */
export const trackPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
  }
};

/**
 * Track a standard Meta Pixel event
 * @param {string} eventName - Standard event name (e.g., 'Search', 'ViewContent', 'AddToCart', 'Purchase')
 * @param {object} params - Optional event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', eventName, params);
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Custom event name
 * @param {object} params - Optional event parameters
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, params);
  }
};

/**
 * Standard Meta Pixel Events for reference:
 * - PageView: Track page views (automatically tracked on load)
 * - ViewContent: When a user views a product or content
 * - Search: When a user performs a search
 * - AddToCart: When a user adds an item to cart
 * - AddToWishlist: When a user adds an item to wishlist/favorites
 * - InitiateCheckout: When a user starts checkout
 * - Purchase: When a user completes a purchase
 * - Lead: When a user signs up or submits info
 * - CompleteRegistration: When a user completes registration
 */

export default {
  trackPageView,
  trackEvent,
  trackCustomEvent
};


